<div class="flex flex-col">
  <div class="flex flex-row text-sm color-primary">
    <span>{{item().cartikelnummer}}</span>
  </div>
  <div class="flex flex-row">
    <span class="font-bold">{{item()[5]}}</span>
  </div>
  @if (item()[26]) {
    <div class="flex flex-row">
      <span class="text-xs">{{item()[26]}}</span>
    </div>
  }
  @if (item()[27]) {
    <div class="flex flex-row">
      <span class="text-xs">{{item()[27]}}</span>
    </div>
  }
  @if (item()[28]) {
    <div class="flex flex-row">
      <span class="text-xs">{{item()[28]}}</span>
    </div>
  }
  @if (item()[29]) {
    <div class="flex flex-row">
      <span class="text-xs">{{item()[29]}}</span>
    </div>
  }
  @if (item()['lagerstand_gesamt'] !== null && item()['lagerstand_gesamt'] !== undefined && item()['lagereh']) {
    <div class="flex flex-row">
      <span class="text-xs font-semibold text-light">{{ '#WWS_CORE.FOK.ARTSTAMM.LIST.LAGERSTAND' | translate }} {{item()['lagerstand_gesamt'] | number:'1.2-2' }} {{item()['lagereh']}}</span>
    </div>
  }
</div>
